import type {PullRequestAliveData} from './use-refetch-on-alive-update'
import {useInvalidateOnAliveUpdate} from '@github-ui/use-invalidate-on-alive-update'
import {useLabelsQueryKey} from '../components/overview/data/route-queries'
import type {AliveChannels} from '../page-data/payloads/header'

const filter = (data: PullRequestAliveData) => Boolean(data.event_updates?.labels_updated)
const emptyQueryKey = [] as const

export function useLabelsLiveUpdates(aliveChannels: AliveChannels | undefined): void {
  const queryKey = useLabelsQueryKey()

  useInvalidateOnAliveUpdate(queryKey ? (aliveChannels?.pullRequest ?? '') : '', queryKey ?? emptyQueryKey, {
    filter,
  })
}
